import script from "./DisbursementsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisbursementsSection.vue?vue&type=script&setup=true&lang=ts"

import "./DisbursementsSection.vue?vue&type=style&index=0&id=7bf9ba12&scoped=true&lang=css"
import "@/assets/css/certifications/certification-form.css?vue&type=style&index=1&id=7bf9ba12&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf9ba12"]])

export default __exports__